import styled from 'styled-components';

import media from '@/styles/media.style';
import { BLACK, BORDER_GRAY } from '@/styles/variables.style';

export const RunwaySection = styled.section`
  margin: 0;
  padding: 20px 20px 70px 20px;

  ${media.tabletL`
    width: 1000px;
    max-width: 100%;
    margin: 0 auto;
    padding: 40px 20px 120px 20px;
  `};
`;

export const RunwayTitle = styled.h2`
  margin-bottom: 30px;
  font-size: 24px;
  line-height: 26px;
  color: ${BLACK};

  ${media.tabletL`
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 32px;
  `};
`;

export const RunwayWrapper = styled.div`
  display: block;

  ${media.tabletL`
    display: flex;
    align-items: flex-start;
  `};
`;

export const RunwayContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  width: ${({ width }) => width};
  margin: 0;
  margin-right: ${({ paddingRight }) => paddingRight};

  ${media.tabletL`
    &:last-child {
      padding-right: 0;
    }
  `};
`;

export const RunwayImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: ${({ dimension }) => dimension};
  height: ${({ dimension }) => dimension};
  border: solid ${BORDER_GRAY.INSPIRATION} 1px;
`;

// 元の画像にアウトラインが入っている場合を想定
export const RunwayImage = styled.div`
  position: absolute;
  top: 25%;
  left: -1%;
  width: 102%;
  height: 50%;
  margin: 0;
  background: url(${({ srcImage }) => srcImage}) no-repeat center center;
  background-size: cover;

  ${media.tabletL`
    left: -0.1%;
    width: 100.1%;
  `};
`;

export const RunwayDescription = styled.div`
  margin: 20px 0;
  color: ${BLACK};
  font-size: 14px;
  line-height: 16px;

  ${media.tabletL`
    margin: 30px 0;
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const RunwayLinkWrapper = styled.div`
  margin-bottom: 40px;
  color: ${BLACK};
  font-size: 14px;
  line-height: 16px;

  > a {
    text-decoration: underline;
  }

  ${media.tabletL`
    margin-bottom: 0;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/EditorialPage.style.js